import { useTranslation } from "react-i18next"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getForSelect as getLotsForSelect } from '../../../actions/other/lotsActions'
import { getBooleanOptions } from "../../../constants/booleanOptions"

export default function EventFormReviewMark({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)
	const { lotsForSelect } = useSelector(state => state.lots)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
		dispatch(getLotsForSelect())
	}, [dispatch])

	const animals = animalsForSelect.map(a => ({ value: a._id, label: a.identifier }))
	const lots = lotsForSelect.map(l => ({ value: l._id, label: l.identifier }))

    const booleanOptions = getBooleanOptions(t)

	const showReviewField = ['status', 'heat'].includes(type)
	const showDetectionDate = type === 'heat'

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t(`menus.event_${type}`)}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.animals')}</Form.Label>
						<Select
							isMulti
							options={animals}
							value={animals.filter(opt => state.animals?.includes(opt.value))}
							onChange={opts => handleInputChange({ target: { name: 'animals', value: opts.map(o => o.value) } })}
							isClearable
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.lots')}</Form.Label>
						<Select
							isMulti
							options={lots}
							value={lots.filter(opt => state.lots?.includes(opt.value))}
							onChange={opts => handleInputChange({ target: { name: 'lots', value: opts.map(o => o.value) } })}
							isClearable
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				{showReviewField && (
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.event.reviewQuestion')}</Form.Label>
							<Select
								options={booleanOptions}
								value={booleanOptions.find(o => o.value === state.review) || null}
								onChange={opt => handleInputChange({ target: { name: 'review', value: opt.value } })}
							/>
						</Form.Group>
					</Col>
				)}
				{showDetectionDate && (
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.event.detectionDate')}</Form.Label>
							<Form.Control
								type="date"
								name="detectionDate"
								value={state.detectionDate || ''}
								onChange={handleInputChange}
								required={showDetectionDate}
							/>
						</Form.Group>
					</Col>
				)}
			</Row>

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}

